/**
 * Захват рекламных меток на витрине Shopify.
 *
 * Задача. Объявление Meta приводит человека на страницу магазина со служебными
 * параметрами в ссылке (utm_* и числовые id кампании, группы и объявления).
 * Пока он ходит по каталогу и собирает корзину, исходная ссылка теряется, а в
 * наш чекаут он попадает уже без неё. Поэтому метки нужно снять при первом
 * заходе и донести до оформления заказа.
 *
 * Почему first-touch, а не last-touch. Сохраняется ПЕРВОЕ рекламное касание
 * сессии: человек кликает объявление, потом уходит в поиск, возвращается по
 * прямой ссылке — заказ всё равно заслуга объявления. Перезапись происходит
 * только при новом рекламном переходе, а не при обычной навигации по сайту.
 *
 * Установка: подключить в теме ДО mono-intercept.js. Скрипт ничего не рисует и
 * не делает запросов — только пишет в sessionStorage.
 *
 *   <script src="{{ 'ad-markers.js' | asset_url }}" defer></script>
 *
 * Шаблон ссылки в рекламном кабинете (Ads Manager → объявление → «Параметры
 * URL»). ad_id обязателен: имя креатива можно переименовать задним числом,
 * числовой идентификатор — нет.
 *
 *   utm_source=meta&utm_medium=paid&utm_campaign={{campaign.name}}
 *   &utm_term={{adset.name}}&utm_content={{ad.name}}
 *   &ad_id={{ad.id}}&adset_id={{adset.id}}&campaign_id={{campaign.id}}
 */
(function () {
  "use strict";

  var STORAGE_KEY = "bw_ad_markers";
  var PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "ad_id",
    "adset_id",
    "campaign_id",
  ];

  function readStored() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      // Приватный режим и заблокированное хранилище: метки просто не переживут
      // переход между страницами. Ломать из-за этого витрину нельзя.
      return null;
    }
  }

  function capture() {
    var search = new URLSearchParams(window.location.search);
    var markers = {};
    var hasAny = false;

    PARAMS.forEach(function (name) {
      var value = (search.get(name) || "").trim();
      if (!value) return;
      markers[name] = value.slice(0, 300);
      hasAny = true;
    });

    // fbclid без utm-меток тоже означает переход из Meta: разметку могли
    // забыть проставить, но факт рекламного клика от этого не исчезает.
    if (!hasAny && search.get("fbclid")) {
      markers.utm_source = "meta";
      markers.utm_medium = "paid";
      hasAny = true;
    }

    if (!hasAny) return readStored();

    markers.landing_url = window.location.href.slice(0, 1000);
    if (document.referrer) markers.referrer = document.referrer.slice(0, 1000);

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(markers));
    } catch (e) {
      /* хранилище недоступно — метки доживут только до конца этой страницы */
    }
    return markers;
  }

  var current = capture();

  /** Метки текущей сессии для скрипта оформления заказа. */
  window.bwAdMarkers = function () {
    return current || readStored() || null;
  };
})();
